/* Shared toast. One host node, one queue, no dependencies.

   It exists because /cart/add can fail for reasons a shopper can act on —
   most of all "Variant can only be purchased with a selling plan", which
   Shopify returns as a raw 422 and the theme answered by dumping the visitor
   on /cart with no explanation. */
(function () {
  if (window.NEToast) return;

  var host = null;

  function ensureHost() {
    if (host && document.body.contains(host)) return host;
    host = document.createElement('div');
    host.className = 'ne-toasts';
    host.setAttribute('role', 'status');
    host.setAttribute('aria-live', 'polite');
    document.body.appendChild(host);
    return host;
  }

  function show(message, kind, ms) {
    if (!message) return;
    var el = document.createElement('div');
    el.className = 'ne-toast' + (kind ? ' ne-toast--' + kind : '');
    el.textContent = message;
    ensureHost().appendChild(el);
    // next frame, so the entry transition has a start state to run from
    requestAnimationFrame(function () { el.classList.add('is-on'); });
    var life = ms || (kind === 'error' ? 6000 : 3200);
    setTimeout(function () {
      el.classList.remove('is-on');
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 260);
    }, life);
  }

  /* Turns a Shopify cart error into something a person can act on.
     Falls back to Shopify's own wording rather than inventing one. */
  show.fromCartError = function (payload) {
    var d = (payload && (payload.description || payload.message)) || '';
    if (/selling plan/i.test(d)) {
      show('This item is set up as a subscription only right now, so it cannot be added as a one-time purchase. Pick Subscribe & Save on the product page, or try again shortly.', 'error', 8000);
      return;
    }
    if (/sold out|not enough items|unavailable/i.test(d)) {
      show('Sorry — there is not enough stock left for that.', 'error');
      return;
    }
    show(d || 'Could not add that to your cart. Please try again.', 'error');
  };

  window.NEToast = show;
})();
